import Resource from "../base/resource";

class _360VideoHotspot extends Resource {

    constructor(props) {
        super(props);
    }

    async load() {
    }

    setState(state) {
        if(!state.hotSpotName && !state.model) {
            videoHotSpotFeature.stopPlayingCurrentPanorama();
            videoHotSpotFeature.onChangeShowAll360Videos(false);
            return;
        }

        const position = new THREE.Vector3(state.position[0], state.position[1], state.position[2]);

        videoHotSpotFeature.getHotSpotInfoFromServer(state.model.id, this.resourceId, position, state.hotSpotName, state.addToType);
        videoHotSpotFeature.hotSpotManager.changeSpotVisibility(state.hotSpotName, state.isVisible);

        if(state.isVisible && state.currentVideo){
            videoHotSpotFeature.processPanoramaVideos(state.hotSpotName);
            videoHotSpotFeature.processCurrentlyVideoPlayingStatus(state.status);
        }

    }

    mergeStates(initialState) {
        if (this.states.length === 0) {
            return initialState;
        }

        let finalState = initialState;
        this.states.forEach(state => {
            finalState.hotSpotName = state.hotSpotName;
            finalState.model = state.model;
            finalState.addToType = state.addToType === 'Scene' ? 1 : 0;
            finalState.position = state.position ? state.position : finalState.position;
            finalState.isVisible = state.isVisible ? state.isVisible : finalState.isVisible;
            finalState.currentVideo = state.currentVideo;
            finalState.status = state.status === "Pause" ? VideoStatus.PAUSED : VideoStatus.PLAYING;
        });

        this.states = [];
        return finalState;
    }

    getDefaultState() {
        return {
            isVisible: false,
            addToType: 0,
            position: [0, 0, 0]
        }
    }
}

export default _360VideoHotspot;
